module.exports = __webpack_public_path__ + "static/media/step-one-big.c8007859.jpg";